import { render, staticRenderFns } from "./PickedUpList.vue?vue&type=template&id=1f2ad8bf"
import script from "./PickedUpList.vue?vue&type=script&lang=js"
export * from "./PickedUpList.vue?vue&type=script&lang=js"
import style0 from "./PickedUpList.vue?vue&type=style&index=0&id=1f2ad8bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports